import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { Project } from '../Project'

@InputType()
export class ComputeProjectTaskProgressArgs extends ActionArgs {
  @Field(() => ID)
  projectId: string
}

export interface IComputeProjectTaskProgress extends IAction<Project, ComputeProjectTaskProgressArgs> {}
